import type { Model } from '#/graphql/types';
import type { ColumnProps } from '#/common/components/DataGrid';
import { getTenantList } from '#/graphql/queries';
import { gql } from '@apollo/client';
import { inUseStatuses } from '../../utils/constants';

const columns: ColumnProps<Model>[] = [
  {
    dataField: 'id',
    caption: 'ID',
    visible: false,
    dataType: 'string',
    showInColumnChooser: false,
  },
  {
    dataField: 'name',
    caption: 'Name',
    dataType: 'string',
    visible: true,
    openOnClick: true,
  },
  {
    dataField: 'manufacturer.name',
    caption: 'Manufacturer',
    openOnClick: true,
    onClick: (e) => {
      e.navigate('/assets/manufacturers/' + e.row.manufacturer?.id);
    },
    visible: true,
    dataType: 'string',
  },
  {
    dataField: 'tenant.name',
    caption: 'Organization',
    dataType: 'string',
    visible: true,
    headerFilter: {
      getItemList: gql(getTenantList),
      displayExpr: 'name',
    },
  },
  {
    dataField: 'inUseStatus',
    caption: 'Status',
    dataType: 'string',
    visible: true,
    lookup: {
      nullable: true,
      dataSource: Object.values(inUseStatuses),
      displayExpr: 'label',
      valueExpr: 'key',
    },
  },
  {
    dataField: 'assetType.name',
    caption: 'Asset Type',
    openOnClick: true,
    onClick: (e) => {
      e.navigate('/assets/types/' + e.row.assetType?.id);
    },
    visible: true,
    dataType: 'string',
  },
  {
    dataField: 'thirdPartyId',
    caption: 'Third Party ID',
    dataType: 'string',
    visible: false,
  },
  {
    dataField: 'thirdPartySource',
    caption: 'Third Party Source',
    dataType: 'string',
    visible: false,
  },
];

export default columns;
